// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___1brKx","content":"styles__content___QfJJz","icon":"styles__icon___39upe","button":"styles__button___10FPJ"};